import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, InputLabel, Select, FormHelperText, MenuItem, ListItemIcon, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SelectController = ({ name, label, control, options, errors }) => {
  return (
    <FormControl error={Boolean(errors[name])}>
      <InputLabel id="form-label-select">{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select {...field} sx={{width:"250px"}} labelId="form-label-select" label={label}>
          <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {options.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
};

export default SelectController;


export const CustomSelectController = ({ name, label, control, options, errors, handleFields,  customStyle }) => {
  return (
    <FormControl error={Boolean(errors[name])} sx={{ width: customStyle ? "180px": "250px"}}>
      <InputLabel id="form-label-select">{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select {...field} sx={{width: customStyle ? "180px": "250px"}} labelId="form-label-select" label={label}
             onChange={(e)=>{handleFields(e.target.value);field.onChange(e.target.value)
            }}
            >
          <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {options.map((option, index) => (
          <MenuItem key={index} value={option.value} >
            {option.label}
          </MenuItem>
        ))}
          </Select>
        )}
      />
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
};
